import React, {useEffect} from 'react';

const FullScreenStreetview = ({toggleMenu, page}) => {

    useEffect(() => {
        toggleMenu('close')
    }, [])

    const content = (page.page_content) ? page.page_content.page_content : '';
    return (
        <div className="homepage-wrapper ">
            <div className="video-wrapper fullscreen-streetview">
                <div dangerouslySetInnerHTML={{__html: content}}/>
            </div>
        </div>
    )
}

export default FullScreenStreetview;
